import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TourService} from './tour.service';
import {Injectable} from '@angular/core';
import {TourApiService} from './tour-api.service';

@Injectable()
export class TourGuard implements CanActivate {

  constructor(private apiService: TourApiService, private tourService: TourService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    // make sure we have a current tour
    if (this.tourService.tour != null) {
      return true;

    } else {
      const relativeURL = '/' + route.url.join('/');
      this.router.navigate(['/'], { queryParams: { returnUrl:  relativeURL}, skipLocationChange: true});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tour.guard.ts